import { render, staticRenderFns } from "./WeChatHomeTab.vue?vue&type=template&id=6bb8387f&scoped=true&"
import script from "./WeChatHomeTab.vue?vue&type=script&lang=js&"
export * from "./WeChatHomeTab.vue?vue&type=script&lang=js&"
import style0 from "./WeChatHomeTab.vue?vue&type=style&index=0&id=6bb8387f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb8387f",
  null
  
)

export default component.exports